/** Templates categories */
export const TEMPLATES_CATEGORIES = {
    ALL: 'All',
    ADS: 'Ads',
    WEBSITE: 'Website',
    SOCIAL_MEDIA: 'Social Media',
    EMAIL: 'Email',
    VIDEO: 'Video',
};
